<div class="Padre">
  <banner-app [Fixtop]="''" [retroSelected]="true" [showPromo]="true"></banner-app>
  <app-inspection-banner></app-inspection-banner>

  <app-stepper [activeStep]="1" class="my-3"></app-stepper>

  <app-texto-principal-planes [nombreTextoPrincipal]="this.nombreTextoPrincipal" [textoInferior]="this.textoInferior"
    class="principalText"></app-texto-principal-planes>

  <div class="paymentCard">

    <div class="cardFinanciero d-flex justify-content-center align-items-center">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-auto p-0">
            <img src="./assets/img/signoPeso.png" width="24px" height="24px" alt="seguro de moto precio" />
          </div>
          <div class="col-auto">
            <span class="tituloFinanciero">Valor asegurado</span>
            <span class="detalleFianciero">${{ vehiclePlusAccesoriesValue ? vehiclePlusAccesoriesValue :
              (datosPlanes?.planes?.data?.products?.[0]?.sumInsured?.amount ?? 0) | customNumberFormat }}</span>
          </div>
        </div>
      </div>
    </div>

    @if(!hidePaymentCheck()){
    <div class="payElection">
      <span class="estiloTextoPagar mx-4">¿Cómo quieres pagar?</span>
      <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
        <input *ngIf="swMensual" type="radio" class="btn-check" name="btnradio1" id="btnradio1" autocomplete="off"
          checked value="Mensual" (click)="radioChangeHandler($event)" />
        <label *ngIf="swMensual" class="btn btn-outline-primary rounded-start-pill estiloTextobotonActivo sizeLabel"
          for="btnradio1">Mensual</label>

        <input *ngIf="!swMensual" type="radio" class="btn-check" name="btnradio1" id="btnradio1" autocomplete="off"
          value="Mensual" (click)="radioChangeHandler($event)" />
        <label *ngIf="!swMensual" class="btn rounded-start-pill estiloTextobotonInactivo sizeLabel"
          for="btnradio1">Mensual</label>

        <input *ngIf="swAnual" type="radio" class="btn-check" name="btnradio2" id="btnradio2" autocomplete="off" checked
          value="Anual" (click)="radioChangeHandler($event)" />
        <label *ngIf="swAnual" class="btn btn-outline-primary rounded-end-pill estiloTextobotonActivo sizeLabel"
          for="btnradio2">Anual</label>

        <input *ngIf="!swAnual" type="radio" class="btn-check" name="btnradio2" id="btnradio2" autocomplete="off"
          value="Anual" (click)="radioChangeHandler($event)" />
        <label *ngIf="!swAnual" class="btn rounded-end-pill estiloTextobotonInactivo sizeLabel"
          for="btnradio2">Anual</label>
      </div>
    </div>
    }
  </div>


  <div *ngIf="swAnual" class="mb-3">
    <app-cards-planes [tipoPlan]="'Annually'" [sessionId]="sessionId"></app-cards-planes>
  </div>

  <div *ngIf="swMensual" class="mb-5">
    <app-cards-planes [tipoPlan]="'Monthly'" [sessionId]="sessionId"></app-cards-planes>
  </div>

  <app-footer-app class="footer-fixed" />
</div>